export const toTableRowItems = (items: ReturoSeal[]) =>
  items.map((item: ReturoSeal) => ({
      id: item.id,
      idNotice: item.idNotice,
      sealCode: item.sealCode || '',
      idReturo: item.idReturo || '',
      shopName: item.shopName || '',
      materialType: item.materialType || '',
      materialTypeValue: item.materialTypeValue || '',
      scanStatus: item.scanStatus || '',
      scanStatusValue: item.scanStatusValue || '',
      createdBy: item.createdBy || '',
      created: item.created || '',
      selectedForNotice: item.selectedForNotice || false
  }))
